import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.XeroInvoiceFields', {
    invoiceDateFieldText: 'Date',
    invoiceDueDateFieldText: 'Due Date',
    invoiceNumberFieldText: 'Invoice #',
    invoiceReferenceFieldText: 'Reference',
    invoiceBrandingThemeFieldText: 'Theme',
});
